import {
  ClientStage,
  IResource,
  RegionResolver,
} from '@amzn/work-spaces-web-client-core-lib';

const AGENTIC_WORKSPACE_CATEGORY = 'AGENTIC';

// Kept in localStorage so the override survives the sign-in redirect.
const FORCE_AGENTIC_STORAGE_KEY = 'ws4b_force_agentic';
const FORCE_AGENTIC_QUERY_PARAM = 'forceAgentic';

// All stages ship a prod build, so only the hostname tells beta from prod.
const PREPROD_STAGES: ReadonlySet<string> = new Set([
  ClientStage.LOCAL,
  ClientStage.BETA,
  ClientStage.GAMMA,
]);

const isDevBuild = (): boolean => process.env.NODE_ENV !== 'production';

const isPreprodStage = (): boolean => {
  try {
    return PREPROD_STAGES.has(RegionResolver.resolveClientStage());
  } catch {
    // An unknown hostname could be customer-facing, so treat it as prod.
    return false;
  }
};

const isOverrideAllowed = (): boolean => isDevBuild() || isPreprodStage();

export const captureForceAgenticFlag = (): void => {
  if (!isOverrideAllowed()) {
    return;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get(FORCE_AGENTIC_QUERY_PARAM) === '1') {
      window.localStorage.setItem(FORCE_AGENTIC_STORAGE_KEY, '1');
    }
  } catch {
    // localStorage is unavailable, so there is nothing to capture.
  }
};

const isForceAgenticActive = (): boolean => {
  if (!isOverrideAllowed()) {
    return false;
  }
  const envFlag = process.env.REACT_APP_FORCE_AGENTIC;
  if (envFlag === '1' || envFlag === 'true') {
    return true;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get(FORCE_AGENTIC_QUERY_PARAM) === '1' ||
      window.localStorage.getItem(FORCE_AGENTIC_STORAGE_KEY) === '1'
    );
  } catch {
    return false;
  }
};

// An older broker omits WorkspaceCategory, which reads as a standard WorkSpace.
export const isAgenticWorkspace = (
  resourceDetails?: Partial<IResource['ResourceDetails']> | null
): boolean => {
  if (isForceAgenticActive()) {
    return true;
  }
  return resourceDetails?.WorkspaceCategory === AGENTIC_WORKSPACE_CATEGORY;
};
